import { adminApi, parseApiError } from './api';
import type { BillingOverview, BillingEvent } from '@/types/admin.types';

const defaultOverview: BillingOverview = {
  mrr: 0,
  arr: 0,
  arpu: 0,
  churnRate: 0,
  newSubscriptions: 0,
  canceledSubscriptions: 0,
  upgrades: 0,
  downgrades: 0,
  grossRevenue: 0,
  refunds: 0,
  fees: 0,
  netRevenue: 0,
};

export const billingService = {
  async getOverview(period?: string): Promise<BillingOverview> {
    try {
      const { data } = await adminApi.get<BillingOverview>('/admin/billing/overview', {
        params: period ? { period } : undefined,
      });
      return data || defaultOverview;
    } catch (error) {
      const err = parseApiError(error);
      if (err.message?.includes('404') || err.message?.includes('Not Found')) {
        return defaultOverview;
      }
      throw err;
    }
  },

  async getEvents(params?: {
    page?: number;
    limit?: number;
    type?: string;
    status?: string;
  }): Promise<{ events: BillingEvent[]; total: number; totalPages: number }> {
    try {
      const { data } = await adminApi.get<{ events: BillingEvent[]; total: number; totalPages: number }>(
        '/admin/billing/events',
        { params }
      );
      return data || { events: [], total: 0, totalPages: 0 };
    } catch (error) {
      const err = parseApiError(error);
      if (err.message?.includes('404') || err.message?.includes('Not Found')) {
        return { events: [], total: 0, totalPages: 0 };
      }
      throw err;
    }
  },

  async refund(paymentIntentId: string, amount: number, reason?: string): Promise<void> {
    try {
      await adminApi.post('/admin/billing/refund', { paymentIntentId, amount, reason });
    } catch (error) {
      throw parseApiError(error);
    }
  },
};

export default billingService;
